import type { FC } from 'react';
import React, { useEffect, useRef } from 'react';
import { banCheating } from '../utils/ban';
interface VideoContainerProps {
  style?: React.CSSProperties;
  className?: string;
}

let isDivDown = false;
let x = 0;
let y = 0;
/** 视频容器 */
const VideoContainer: FC<VideoContainerProps> = ({ className }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const captureRef = useRef(null);
  const container = useRef<HTMLDivElement>(null);
  useEffect(() => {
    getVideo();
    getCapture();
    document.addEventListener('mousemove', onMouseOver);
  }, [videoRef]);

  /** 获取摄像头 */
  function getVideo() {
    window.onblur = () => { };
    navigator.mediaDevices?.getUserMedia({ video: { width: 300 } })
      .then(stream => {
        const video = videoRef.current;
        if (video) {
          video.srcObject = stream;
          video.play();
        }
      })
      .catch(err => {
        // console.error('error:', err);
        console.log('摄像头未找到');
      });
  }

  /** 进行录屏 */
  function getCapture() {
    navigator.mediaDevices?.getDisplayMedia({
      video: {
        cursor: 'always',
        width: 300,
      },
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        sampleRate: 44100,
      },
    })
      .then(stream => {
        const video = captureRef.current;
        video.srcObject = stream;
        video.play();
      })
      .catch(err => {
        console.log('无法录屏');
      });
  }

  /** 鼠标按下 */
  const onMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if(container.current) {
      isDivDown = true;
      x = e.pageX - container.current.offsetLeft;
      y = e.pageY - container.current.offsetTop;
    }
  };

  /** 鼠标抬起 */
  const onMouseUp = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    isDivDown = false;
  };

  /** 鼠标经过 */
  const onMouseOver = (e: MouseEvent) => {
    if (isDivDown && container.current) {
      const div = container.current;
      div.style.top = String(e.pageY - y) + 'px';
      div.style.left = String(e.pageX - x) + 'px';
    }
  };

  return (
    // <div ref={container} onMouseDown={onMouseDown} onMouseUp={onMouseUp} onMouseOver={onMouseOver} style={{
    <div ref={container} onMouseDown={onMouseDown} onMouseUp={onMouseUp} style={{
      width: '300px',
      height: '300px',
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      left: 'calc(100vw - 300px)',
      top: 100,
      backgroundColor: '#ccc'
    }}>
      <video ref={videoRef} />
      <video ref={captureRef} />
    </div>
  );
};

export default VideoContainer;
